const SIGNIN = 'signin';
const SIGNIN_CALLBACK = 'signin-callback';
const RECOVERY = 'recovery';
const SIGNUP = 'signup';
const SIGNUPEN = 'signup-en';
const SIGNUP_CALLBACK = 'signup-callback';
const SIGNUP_CPA_CALLBACK = 'signup-cpa-callback';
const SIGNUPCPA = 'signup-cpa';
const SIGNUP_LIBEO = 'signup-libeo';
const SIGNUP_AXONAUT = 'signup-axonaut';
const SIGNUP_ODOO = 'signup-odoo';
const SIGNUP_EVOLIZ = 'signup-evoliz';
const SIGNUP_PENNYLANE = 'signup-pennylane';
const SIGNUP_PROGBAT = 'signup-progbat';
const SIGNUP_PARTNER = 'signup-partner';
const SIGNUPRCA = 'signup-cpa-rca';
const COMPLETE_SIGNUP = 'completeSignUp';
const ACCEPT_INVITE = 'acceptInvite';
const WEBHOOKS = 'webhooks';
const MAINTENANCE = 'maintenance';

export default [
  SIGNIN,
  SIGNIN_CALLBACK,
  RECOVERY,
  SIGNUPEN,
  SIGNUP,
  SIGNUP_CALLBACK,
  COMPLETE_SIGNUP,
  SIGNUP_CPA_CALLBACK,
  ACCEPT_INVITE,
  SIGNUPCPA,
  SIGNUPRCA,
  SIGNUP_LIBEO,
  SIGNUP_AXONAUT,
  SIGNUP_ODOO,
  SIGNUP_EVOLIZ,
  SIGNUP_PENNYLANE,
  SIGNUP_PROGBAT,
  SIGNUP_PARTNER,
  WEBHOOKS,
  MAINTENANCE,
];
